// oauthRedirect.js - Pure helper for deciding whether App.jsx should redirect on OAuth callback.
// Extracted so the logic can be unit-tested without rendering the full App component.
import { OAUTH_CONFIG } from '../config/oauth';

/**
 * Determine whether the app should perform an OAuth redirect to /login.
 *
 * @param {Object} params
 * @param {string} params.pathname - window.location.pathname
 * @param {string} params.hash     - window.location.hash
 * @param {boolean} params.isMobile - Capacitor.isNativePlatform()
 * @param {string} params.href      - window.location.href
 * @returns {boolean} true if App.jsx should redirect to '/login' + hash
 */
export function shouldRedirectToLogin({ pathname, hash, isMobile, href }) {
  // OAuthCallback component owns the /oauth-callback route; App.jsx must not interfere.
  if (pathname === OAUTH_CONFIG.callbackPath) {
    return false;
  }

  const isRedirectPage = OAUTH_CONFIG.isRedirectPage(href);

  // Only redirect if we have an OAuth token and we're on the redirect page or mobile
  if ((isRedirectPage || isMobile) && hash && hash.includes('access_token=')) {
    // Prevent infinite loop if already on login with the token
    if (pathname === '/login') {
      return false;
    }
    return true;
  }

  return false;
}
